import { doRequest } from '../../../Request';
import { APIQuoteData } from '../../types/apiQuote';
import { toQueryParams } from '../getQuote';

const getAPIQuote: (quoteId: string) => Promise<APIQuoteData> = (quoteId: string) => {
  const include = toQueryParams({
    orders: true,
    prices: true,
    bulkQuote: true,
    nni: true,
    shadowNni: true,
    nniPop: true,
    shadowNniPop: true,
    aEndSupplierNNI: true,
    bEndSupplierNNI: true,
    onatAddresses: true,
    messages: true,
    secondaryPops: true,
  });

  return doRequest({
    path: `/lq-quotes/${quoteId}?include=${include}`,
  });
};

export default getAPIQuote;
